<!-- <app-survey style="z-index:1000">
</app-survey> -->
<app-loading-bar></app-loading-bar>

<!-- Empty State: Show when user has no organisations -->
<ng-container *ngIf="!organisations || organisations.length === 0">
    <div style="width: 100%; min-height: 94vh; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 20px; box-sizing: border-box;">
        <div style="text-align: center; max-width: 600px; width: 100%;">
            <i class="fas fa-inbox" style="font-size: 80px; color: #cccccc; margin-bottom: 20px; display: block;"></i>
            <h1 style="font-size: 28px; color: #333; margin: 20px 0;">{{'No Organisations Yet' | translate}}</h1>
            <p style="font-size: 16px; color: #666; margin: 15px 0;">{{'Welcome! You don\'t have any organisations yet. Create one to get started managing your locations, rooms, and bookings.' | translate}}</p>
            
            <button mat-raised-button color="primary" (click)="openOnboarding()" style="margin-top: 30px; margin-bottom: 30px; padding: 12px 30px; font-size: 16px; white-space: normal; height: auto; line-height: 1.5;">
                <i class="fas fa-plus" style="margin-right: 8px;"></i>{{'Create New Organisation' | translate}}
            </button>

            <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;">
            
            <p style="font-size: 14px; color: #666; margin: 20px 0;">
                {{'If you only want to create a booking, go directly to your location\'s booking URL instead.' | translate}}
            </p>
        </div>
    </div>
</ng-container>

<!-- Normal View: Show when user has organisations -->
<ng-container *ngIf="organisations && organisations.length > 0">
<div class="flex" style="min-height:94vh;">
    <div class="sidebar">


        <div class="select-wrapper organisation-name">
            <div class='desc'>{{'Select Organisation' | translate}}</div>
            <mat-select #orgSelect [value]="selectedOrganisationId" (selectionChange)="setLastOrganisation($event.value)">
              <mat-option [value]="organisation?._id" *ngFor="let organisation of organisations">{{organisation?.organisationName}}</mat-option>
            </mat-select>
        </div>

        <span (click)="setActive('dashboard')" [ngClass]="{'active': activeNavigation === 'dashboard'}" class="item"><i class="fas fa-chalkboard"></i><span class="hide-mobile">{{'Dashboard' | translate}}</span></span>
        <span (click)="setActive('bookings')" [ngClass]="{'active': activeNavigation === 'bookings'}" class="item"><i class="fas fa-calendar-check"></i><span class="hide-mobile">{{'Bookings Management' | translate}}</span></span>
        <span data-intro='Here you can add a new Location' (click)="selectLoc(null)" [ngClass]="{'active': activeNavigation === 'locations'}" class="item"><i class="fas fa-location-arrow"></i><span class="hide-mobile">{{'Locations' | translate}}</span>
        </span>
        <span (click)="selectLoc(location)" [ngClass]="{'active': activeNavigation === 'locations'}" class="item sub hide-mobile" *ngFor="let location of locations">
            <i *ngIf="!location.mapUrl" title="Location Map missing." style="margin-right: 3px;
                    color: #ffb352;" class="fa fas fa-exclamation-triangle"></i>
            {{location.name}}
        </span>
        <span (click)="setActive('organisation')" [ngClass]="{'active': activeNavigation === 'organisation'}" class="item"><i class="fas fa-cog"></i><span class="hide-mobile">{{'Global Settings' | translate}}</span></span>

        <span (click)="setActive('remoteoffice')" [ngClass]="{'active': activeNavigation === 'remoteoffice'}" class="item "><i class="fas fa-globe-europe"></i><span class="hide-mobile">{{'Mobile Office' | translate}} <span class="badge" [ngClass]="{'active': this.organisations[0].mobileOffice, 'inactive' : !this.organisations[0].mobileOffice }" *ngIf="this.organisations && this.organisations[0]">{{ (this.organisations[0].mobileOffice ? 'Active' : 'Inactive') | translate}}</span></span>
        </span>
        <!-- <span (click)="setActive('pricing')" [ngClass]="{'active': activeNavigation === 'pricing'}" class="item"><i class="fas fa-money-check"></i><span class="hide-mobile">{{'My Account' | translate}}</span></span>
        <span style="cursor:not-allowed;opacity:0.4" [ngClass]="{'active': activeNavigation === 'analytics'}" class="item hide-mobile"><i class="far fa-chart-bar"></i><span class="hide-mobile">{{'Analytics' | translate}} <span class="badge">{{'Soon' | translate}}</span></span>
        </span> -->
        <span *ngIf="userService.isSuperAdmin()" style="border-top:1px solid #404040;font-size:12px;margin-top:5px" class="item hide-mobile">{{'Admin Menu' | translate}}</span>
        <span (click)="setActive('superadmin')" *ngIf="userService.isSuperAdmin()" [ngClass]="{'active': activeNavigation === 'superadmin'}" class="item hide-mobile"><i class="fa fa-diamond"></i><span class="hide-mobile">{{'Superadmin' | translate}} Menu </span>
        </span>

        <span (click)="openOnboarding()" *ngIf="userService.isSuperAdmin()" class="item hide-mobile"><i class="far fa-plus-square"></i><span class="hide-mobile">{{'Show Onboarding' | translate}} </span>
        </span>

        <section *ngIf="userService.isSuperAdmin() && isNightly()" class="flex column envSelect">
            <label class="example-margin hide-mobile"><i class="fa fa-building-o" aria-hidden="true" style="margin-right:15px"></i>Environment</label>
            <mat-radio-group (change)="envChange($event)" ngDefaultControl [(ngModel)]="environments" class=" hide-mobile flex column rgroup">
                <mat-radio-button class="mb10" style="margin-top:10px" value="localhost">
                    Localhost
                </mat-radio-button>
                <mat-radio-button class="mb10" value="nightly">
                    Nightly
                </mat-radio-button>
                <mat-radio-button disabled class="mb10" value="qa">
                    QA
                </mat-radio-button>
                <mat-radio-button disabled class="mb10" value="prod">
                    Prod
                </mat-radio-button>
            </mat-radio-group>
        </section>

<!--         <section class="flex column">
            <div class="powered-by">
                <span>Powered by</span><br>
                <img src="../../assets/img/REHAU_Logo-NewVentures_1c_white.svg">
            </div>
        </section> -->

    </div>




    <div class="content-big " id="content-holder " style="border-radius: 0px; overflow: scroll; ">

        <ng-container *ngIf="activeNavigation==='dashboard' ">
            <app-dashboard-overview [organisations]="organisations "></app-dashboard-overview>
        </ng-container>

        <ng-container *ngIf="activeNavigation==='superadmin' ">
            <app-superadmin [organisations]="organisations "></app-superadmin>
        </ng-container>

        <!--
        <ng-container *ngIf="activeNavigation==='map' ">
            <app-table-manager></app-table-manager>
        </ng-container>
        -->

        <ng-container *ngIf="activeNavigation==='locations' ">
            <app-location [selectedLocation]="selectedLocation"></app-location>
        </ng-container>

        <ng-container *ngIf="activeNavigation==='rooms' ">
            <app-room></app-room>
        </ng-container>

        <ng-container *ngIf="activeNavigation==='organisation' ">
            <app-organisation [organisations]="organisations "></app-organisation>
        </ng-container>


        <ng-container *ngIf="activeNavigation==='items' ">
            <app-items [organisations]="organisations "></app-items>
        </ng-container>

        <ng-container *ngIf="activeNavigation==='pricing' ">
            <app-pricing-plans></app-pricing-plans>
        </ng-container>


        <ng-container *ngIf="activeNavigation==='remoteoffice'">
            <app-remote-office-admin [organisations]="organisations "></app-remote-office-admin>
        </ng-container>

        <ng-container *ngIf="activeNavigation==='bookings'">
            <app-bookings-management></app-bookings-management>
        </ng-container>

    </div>

</div>


<div class="print-small ">

    <div class="flex " style="place-content: center;flex-wrap: wrap; ">
        <div *ngFor="let item of items " style="flex: 0 0 33%;position: relative; ">

            <p style="text-align: center; font-size: 10px;position: relative; top: 20px; ">{{item.name}}</p>
            <div>
                <img style="width: 150px;display: block; margin-left: auto; margin-right: auto " [src]="getSmallImgUrl(item) ">
            </div>
            <p style="text-align: center; font-size: 10px; color: #ef575f; position: relative; top: -22px; ">Powered by Crewcus</p>
        </div>
    </div>
</div>

<!-- <ng-container *ngIf="organisations?.length===0  || showOnboarding">
     <app-onboarding></app-onboarding> 

</ng-container> -->
</ng-container>
